import React from 'react';

import { observer } from 'mobx-react';
import classNames from 'classnames';

import classes from './OrderDetailsBlock.module.scss';
import { HeaderLogo } from '../../../../shared/components/header-components/HeaderLogo/HeaderLogo';
import { TimerBlock } from './TimerBlock/TimerBlock';
import { PriceInfo } from './PriceInfo/PriceInfo';
import { DetailsTable } from '../../../components/checkout/DetailsTable/DetailsTable';
import { Footer } from '../../../components/checkout/Footer/Footer';
import { checkoutStore } from '../../../stores/checkoutStore';
import {
  SolutionType,
  SOLUTION_TYPE,
} from '../../../../shared/constants/user-info/solutionType';
import { getPriceForSubscription } from './utils/getPriceForSubscription';
import { getRouteParam } from '../../../../shared/utils/angularUtils';
import { checkoutQueryParams } from '../../../constants/pathQueryParams';

type OrderDetailsBlockProps = {
  solution: SolutionType;
};

const OrderDetailsBlock = observer(({ solution }: OrderDetailsBlockProps) => {
  const { checkoutInfo, subscriptionTypeFlags } = checkoutStore;

  const consultationType = getRouteParam(checkoutQueryParams.consultationType);

  if (!checkoutInfo) {
    return null;
  }

  const { subscription, checkoutDetails, coach, tax, entity } = checkoutInfo;

  return (
    <div className={classes.container}>
      <div>
        <div
          className={classNames(classes.logoWrapper, {
            [classes.scanIq]: solution === SOLUTION_TYPE.SCAN_IQ,
          })}
        >
          <HeaderLogo solution={solution} />
        </div>
        <div className={classes.content}>
          {!subscriptionTypeFlags.SCAN_IQ && <TimerBlock />}
          <PriceInfo />
          <DetailsTable
            targetName={subscription.name}
            totalAmount={checkoutDetails.totalAmount}
            taxAmount={checkoutDetails.taxAmount}
            price={getPriceForSubscription(subscription, subscriptionTypeFlags)}
            businessName={entity.businessName}
            coach={coach}
            tax={tax}
            consultationType={consultationType}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
});

export { OrderDetailsBlock };
